import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../shared/contract.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {

  constructor(){}
  ngOnInit(){}
  
  



}
